import React, { useState, useEffect } from 'react';
import { getAssets, saveAssetDisposal } from '../../../services/asset.service';

import { DataGrid } from '@mui/x-data-grid';
// import axios from "axios";
// import { read } from "xlsx";



const columns = [

    {"field":"sl_no","hideable":true,"hide":false,"headerName":"Sl No","width":50},
    {"field":"din_no","hideable":true,"hide":true,"headerName":"DIN No","width":50},
    {
        "field": "tag",  "hide": false, "headerName": "TAG", "width": 80,
        renderCell: (params) => (
            <a href={`/asset-disposal?tag=${params.value}`}>{params.value}</a>
        )
    },
    { "field": "final_buyer_no", "hideable": true, "hide": false,  "headerName": "Final Buyer No", "width": 130 },
    { "field": "final_buyer_name",  "hide": false, "headerName": "Final Buyer Name", "width": 130 },
    { "field": "price_quoted",  "hide": false, "headerName": "Price Quoted", "width": 130 },
    { "field": "final_sale_price_w/o_gst",  "hide": false, "headerName": "Final Sale Price W/o GST", "width": 130 },
    { "field": "date_of_sale",  "hide": false, "headerName": "Date of Sale", "width": 130 },
    { "field": "final_approval_date",  "hide": false, "headerName": "Final Approval Date", "width": 130 },
    { "field": "final_approval_by",  "hide": false, "headerName": "Final Approval By", "width": 130 },

];

function BulkFinalizeDealList() {
    const [items, setItems] = useState([]);
    var onCellEditStopFn = (event, newCell) => {
        var obj = {};
        obj[newCell.field] = event.target.value;
    }

    useEffect(() => {
        var data1= {
            'company_id':sessionStorage.getItem('LoggedInCompanyId'),
            'division_id':sessionStorage.getItem('LoggedInDivisionId'),
          }
        /*getAssets(data1).then(function (res) {
            //if(res?.data?.data) {
            if (res?.data?.data?.length) setItems(res.data.data);
        })*/
    }, [])

    // readAssets();
    return (
        <div className='container'>
            <h3>
                <h2> Bulk Finalize Deal List</h2>

            </h3>
            <DataGrid
                rows={items}
                getRowId={(row) => row.sl_no}
                columns={columns}
                pageSize={5}
                autoHeight
                rowsPerPageOptions={[5]}
                onCellEditStop={onCellEditStopFn}
            />


        </div>
    )
}

export default BulkFinalizeDealList


